import _ from 'lodash'
// import Promise from 'bluebird'
import EventEmitter from 'wolfy87-eventemitter'
import {Libs} from 'eyes-lib/es'
import * as menu from './modules/menu'
import * as Store from './modules/store'

/** 利用する機能を選出 */
const {SearchDomState, SearchMenuOption} = Store
const {registToGlobal} = Libs
const {convertToState} = menu

export class SearchController extends EventEmitter {

	/**
	 * @constructor
	 * @param {Partial<SearchControllerParams>} options 
	 */
	constructor(options) {
		super()
		this.API_PATH = _.get(options, 'API_PATH')
		this.OVERWRITE = _.get(options, 'OVERWRITE', false)
		this.SEARCH_PATH = _.get(options, 'SEARCH_PATH')
		this.BRANCH_GCD = _.get(options, 'BRANCH_GCD')
		this.baseOptions = Object.assign({}, options)
		this.callback = null
	}

	/**
	 *
	 *
	 * @param {Function} callback
	 * @memberof SearchController
	 */
	load(callback) {
		this.callback = callback

		/** Firefoxでブラウザバック時、jsが動かない対策 */
		window.onunload = function () {}

		this.run()
			.then( () =>
			{
				if (_.isFunction(this.callback)) {
					this.callback(menu)
				}
				this.emit('load', menu)
			})
			.catch( err =>
			{
				_.defer(() => {
					throw err
				})
			})
	}

	async run() {
		/** READYイベントを待つPromise */
		const onReady = new Promise((resolve) => {
			menu.event.once(menu.EVENTS.READY, () => {
				resolve(menu.EVENTS.READY)
			})
		})

		await menu.boot(this.API_PATH)

		/** URLクエリパラメータをオブジェクト化 */
		const urlInfo = Libs.urlInfo()

		/** クエリオブジェクトから検索状態に適用するオブジェクトに変換 */
		const urlState = convertToState(
			this.OVERWRITE
				? Object.assign({}, this.baseOptions, urlInfo.param)
				: Object.assign({}, urlInfo.param, this.baseOptions),
		)
		// console.log({urlState})
		/** 各検索マスタグループを抽出 */
		const groupState = _.pick(urlState, [
			'dep_grp',
			'hmn_grp',
			'cho_grp',
			'trf_grp',
			'tem_grp',
			'ysn_grp',
			'pax_grp',
			'branch_cd',
		])
		// console.log({groupState})

		/** 検索メニュー制御オプション設定 */
		const menuOpt = SearchMenuOption.new()

		/** 検索ボタンでの画面遷移設定 */
		menuOpt.goto = true

		menuOpt.API_PATH = this.API_PATH
		menuOpt.SEARCH_PATH = this.SEARCH_PATH

		/** 各検索マスタグループをマージ */
		_.merge(menuOpt, groupState)

		// console.log({menuOpt})
		/** 検索メニューに息吹を */
		await menu.searchMenu(this.BRANCH_GCD, menuOpt)

		/** URL状態を検索状態に適用 */
		Store.domStateMerge(SearchDomState, urlState)
		// console.log({SearchDomState})

		await onReady
	}
}

/** グローバルに公開 */
registToGlobal('SearchController', SearchController)
